"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetStandAloneProvider = void 0;
const react_1 = __importStar(require("react"));
const use_toggle_or_set_1 = __importDefault(require("./private/use_toggle_or_set"));
const lodash_1 = require("lodash");
const core_1 = require("../core");
const widget_context_1 = require("./widget_context");
const global_context_1 = require("./global_context");
const components_1 = require("@apitable/components");
/**
 * WidgetProvider for standalone widget,
 * with its own data loading capabilities and resourceService.
 * Multiple widgets can be loaded in a page, just wrap WidgetProvider on the outer layer of each widget.
 */
const WidgetStandAloneProvider = props => {
    const { resourceService, globalStore } = (0, react_1.useContext)(global_context_1.GlobalContext);
    const [isSettingOpened, { toggle: toggleSetting }] = (0, use_toggle_or_set_1.default)(true);
    const [isExpanded, { toggle: toggleExpand }] = (0, use_toggle_or_set_1.default)(false);
    const { id, datasheetId, locale = 'zh-CN', className, style, children } = props;
    (0, react_1.useEffect)(() => {
        // get datasheet data under datasheetId, listen under connectWidgetStore
        resourceService.switchResource({ to: datasheetId, resourceType: core_1.ResourceType.Datasheet });
        // get globalStore of the widget need
        globalStore.dispatch(core_1.StoreActions.fetchWidgetsByWidgetIds([id]));
    }, [id, datasheetId, resourceService, globalStore]);
    return (react_1.default.createElement(widget_context_1.WidgetProvider, { id: id, theme: components_1.ThemeName.Light, locale: locale, isFullscreen: isExpanded, isShowingSettings: isSettingOpened, toggleSettings: toggleSetting, toggleFullscreen: toggleExpand, expandRecord: lodash_1.noop, className: className, widgetStore: globalStore, style: style }, children));
};
exports.WidgetStandAloneProvider = WidgetStandAloneProvider;
